import { ComponentStyleConfig } from '@chakra-ui/react'

export default <ComponentStyleConfig>{
  baseStyle: {
    track: {
      // bg: 'gray.400',
    },
    thumb: {
      _focus: {
        boxShadow: 'none',
      },
      _hover: {
        // boxShadow: '2px 2px 6px rgba(255, 51, 119, 0.4)',
      },
    },
  },
}
